import { BlogList } from '@/blocks/BlogList'
import { LATEST_ARTICLES_SORT, QUERY_OTHER_ARTICLES } from '@/core/blog/constants'
import { ArticlesContextProvider } from '@/providers'

import type { BlogLayoutProps } from '../BlogLayout'

export function OtherArticlesSection({ othersArticles }: Pick<BlogLayoutProps, 'othersArticles'>) {
  return (
    <ArticlesContextProvider
      articles={othersArticles}
      sort={LATEST_ARTICLES_SORT}
      query={QUERY_OTHER_ARTICLES}
      perPage={6}
    >
      <BlogList title={{ text: 'Você também pode se interessar' }} showMore />
    </ArticlesContextProvider>
  )
}
